import React from 'react';
import './TruckImageSection.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import truckImageWebp from '../../Assets/images/truck_image_section.webp';
import truckImage from '../../Assets/images/truck_image_section.png';

const TruckImageSection = () => {
  const sectionRef = useAnimateOnScroll();

  return (
    <section ref={sectionRef} className="truck-image-section scale-in">
      <picture>
        <source srcSet={truckImageWebp} type="image/webp" />
        <img
          src={truckImage}
          alt="Heavy duty dump truck at night"
          className="truck-image-section__img"
          width="1423"
          height="626"
        />
      </picture>
    </section>
  );
};

export default TruckImageSection;
